import { Button, Checkbox, Col, Divider, Modal, Row, Spin, Typography } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { checkCanProcessApproval } from "src/services/map-company-user.service";
import Warning from "src/components/GlobalIconPart/Warning";

interface Month {
  label: string;
  value: string;
  statusFlowActive?: boolean;
}

const CheckboxGroup = Checkbox.Group;
const { Text } = Typography;

const ModalApproveMonth = (props: {
  open: boolean;
  intitailMonthly: Month[] | [];
  loading: boolean;
  loadingOption?: boolean;
  onSubmitReport: (data: any) => void;
  onCancelReport: () => void;
}) => {
  const { open, intitailMonthly, loading, loadingOption, onSubmitReport, onCancelReport } = props;
  const [checkedMonths, setCheckedMonths] = useState<string[]>([]);
  const [isWarningApproval, setIsWarningApproval] = useState<boolean>(false);

  const onChange = (checkedValues: string[]) => {
    setCheckedMonths(checkedValues);
  };

  const checkCanApproval = async () => {
    try {
      const response = await checkCanProcessApproval();
      if (response.data.code === 200) {
        if (response.data.data === true) {
          setIsWarningApproval(false);
        }
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error?.response?.status === 400) {
          setIsWarningApproval(true);
        }
      }
      console.error(error);
    }
  };

  useEffect(() => {
    checkCanApproval();
  }, []);

  return (
    <div>
      <Modal
        open={open}
        title={
          <div>
            <Text>Please select a month to send for approval.</Text>
            {isWarningApproval && (
              <Row className="mt-2 flex items-center justify-center text-center">
                <Warning />
                <Text type="danger">There is no approver on this report.</Text>
              </Row>
            )}
          </div>
        }
        width={500}
        okText="Submit"
        centered
        style={{ textAlign: "center" }}
        onCancel={onCancelReport}
        footer={
          <Row className="w-full border-t" justify={"end"}>
            <Button
              className="mt-4"
              key="submit"
              type="primary"
              onClick={() => onSubmitReport(checkedMonths)}
              loading={loading}
              disabled={checkedMonths.length == 0}
            >
              Submit
            </Button>
          </Row>
        }
      >
        <Spin spinning={loadingOption ? true : false}>
          <Divider />
          <div style={{ padding: "8px" }}>
            <CheckboxGroup value={checkedMonths} onChange={onChange} style={{ width: "80%" }}>
              <Row gutter={[16, 16]}>
                {intitailMonthly?.map((month, index) => (
                  <Col span={8} key={index} style={{ textAlign: "left" }}>
                    <Checkbox value={month.value} disabled={month.statusFlowActive}>
                      {month.label}
                    </Checkbox>
                  </Col>
                ))}
              </Row>
            </CheckboxGroup>
          </div>
        </Spin>
      </Modal>
    </div>
  );
};

export default ModalApproveMonth;
